// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__Wakgw","emptylist":"styles_emptylist__2uTp7"};